/* eslint-disable */
(function () {
  const SELECTORS = [
    '#gallery-row-indicator',
    '#gallery-scroll-indicator',
    '.gallery-indicator',
    '.product__media-nav',
    '.slider-buttons',
    '[data-product-media-slider]'
  ];

  const MEDIA_WRAPPER = '.product__media-wrapper';

  function $all(root, sel) {
    try { return Array.from((root || document).querySelectorAll(sel)); } catch { return []; }
  }

  function getClosestWrapper(node) {
    return node?.closest(MEDIA_WRAPPER);
  }

  function ensureInsideWrapper() {
    const wrappers = $all(document, MEDIA_WRAPPER);
    if (!wrappers.length) return;

    // Знайти всі потенційні індикатори
    const indicators = SELECTORS.flatMap(sel => $all(document, sel));

    indicators.forEach(ind => {
      if (!ind || !document.contains(ind)) return;

      let wrapper = getClosestWrapper(ind);

      // якщо індикатор поза медіа — перемістити в найближчий видимий wrapper у межах секції продукту
      if (!wrapper) {
        // беремо перший wrapper, що у viewport (або перший взагалі)
        wrapper = wrappers.find(w => {
          const r = w.getBoundingClientRect();
          return r.width > 0 && r.height > 0;
        }) || wrappers[0];

        if (wrapper) {
          // переміщуємо індикатор в wrapper
          wrapper.appendChild(ind);
        }
      }

      // Прочистити стилі, які могли фіксувати до екрана
      ind.style.position = 'absolute';
      ind.style.left = '12px';
      ind.style.top = '';
      ind.style.bottom = '';
      ind.style.right = '';
      ind.style.transform = '';

      // Вертикальне центрування для десктопу, як у CSS
      if (window.innerWidth >= 750) {
        ind.style.top = '50%';
        ind.style.transform = 'translateY(-50%)';
      } else {
        // мобільний — у верх
        ind.style.top = '16px';
        ind.style.transform = '';
      }

      ind.style.zIndex = '10';
      ind.style.pointerEvents = 'auto';
    });
  }

  // Дебаунс
  let raf, tid;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    if (tid) clearTimeout(tid);
    raf = requestAnimationFrame(() => {
      tid = setTimeout(ensureInsideWrapper, 60);
    });
  }

  // Старт
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });

  // На випадок lazy/section reload
  const mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();